import type { FaireRetailerEntity } from "../../entity_types/retailer";

export const r_bvuv8mj0x6: FaireRetailerEntity = {
  token: "r_bvuv8mj0x6",
  type: "retailer",
  name: "Aloha Adventure Farms",
  themeTokens: [
    "puka-pearl-beach-jewelry",
    "recycled-glass-tiki-bar",
    "island-snack-souvenirs",
    "aloha-paper-goods",
    "pineapple-perfect-tea-towels",
    "island-scents-car-home",
    "coconut-teak-tabletop-treasures",
    "island-inspired-natural-soaps",
    "shell-coastal-keepsake-d-cor",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:42Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
